import { cn, Flex } from '@bridebook/aura';

type Props = {
  count: number;
  activeIndex: number;
  onDotClick?: (index: number) => void;
  className?: string;
  classNames?: {
    dot?: string;
  };
  ariaLabel?: string;
};

export const CarouselDots = ({
  count,
  activeIndex,
  onDotClick,
  className,
  classNames,
  ariaLabel = 'Photo navigation',
}: Props) => (
  <Flex
    className={cn('absolute bottom-4 left-1/2 z-20 -translate-x-1/2 gap-3', className)}
    role="tablist"
    aria-label={ariaLabel}>
    {Array.from({ length: count }).map((_, index) => (
      <button
        key={index}
        type="button"
        role="tab"
        data-state={index === activeIndex ? 'active' : 'inactive'}
        aria-selected={index === activeIndex}
        aria-label={`Photo ${index + 1} of ${count}`}
        onClick={() => onDotClick?.(index)}
        disabled={!onDotClick}
        className={cn(
          'flex size-3 items-center justify-center rounded-full transition-colors duration-300 @screen-md:size-4',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
          !classNames?.dot && [
            'data-[state=active]:bg-[var(--ww-palette-cta)]',
            'data-[state=inactive]:bg-white/50',
            onDotClick && 'data-[state=inactive]:hover:bg-white/70',
          ],
          !onDotClick && 'pointer-events-none cursor-default',
          classNames?.dot,
        )}
      />
    ))}
  </Flex>
);
